import { useCallback } from 'react';
import { linkWarehouses } from '#entities/warehouse';
import { type OpenApiSchemaLinkWarehouseRequest } from '#shared/api/schema';
import { OZON_SERVICE_NAME } from '#shared/lib/brand';
import { showError } from '#shared/lib/toast';
import { type WarehouseToCompare } from '../types';

export const useHandleSave = ({
    warehousesToCompare,
    isLoading,
    toggleLoading,
    onClose,
    handleSetErrorMessage,
}: {
    warehousesToCompare: WarehouseToCompare[];
    isLoading: boolean;
    toggleLoading: (value: boolean) => void;
    onClose: VoidFunction;
    handleSetErrorMessage: (message: string) => void;
}) =>
    useCallback(async () => {
        if (isLoading) {
            return;
        }

        if (warehousesToCompare.length === 0) {
            return;
        }

        const isAllWarehousesHaveTwinWarehouseId = warehousesToCompare.every((warehouse) =>
            Boolean(warehouse.twin_warehouse_id)
        );

        if (!isAllWarehousesHaveTwinWarehouseId) {
            handleSetErrorMessage(`Необходимо указать связанный склад для всех складов ${OZON_SERVICE_NAME} FBS`);

            return;
        }

        const isAllUniqueTwinWarehouseIds = warehousesToCompare.every(
            (warehouse) =>
                warehousesToCompare.filter((w) => w.twin_warehouse_id === warehouse.twin_warehouse_id).length === 1
        );

        if (!isAllUniqueTwinWarehouseIds) {
            handleSetErrorMessage(
                `Необходимо указать уникальный связанный склад для каждого склада ${OZON_SERVICE_NAME} FBS`
            );

            return;
        }

        const payload: OpenApiSchemaLinkWarehouseRequest = {
            twins: warehousesToCompare.map((warehouse) => {
                return {
                    main_twin: warehouse.id,
                    dependent_twin: warehouse.twin_warehouse_id,
                };
            }),
        };

        try {
            toggleLoading(true);

            await linkWarehouses(payload);

            onClose();
        } catch (error) {
            showError({ label: 'Произошла ошибка при сопоставлении складов' }, error);
        } finally {
            toggleLoading(false);
        }
    }, [warehousesToCompare, handleSetErrorMessage, onClose, isLoading, toggleLoading]);
